"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = exports.State = exports.AppSettings = exports.DASHBOARD_TILES = void 0;
const class_transformer_1 = require("class-transformer");
const api_1 = require("./api");
const client_1 = require("./client");
const model_1 = require("./model");
const utils_1 = require("./utils");
const payroll_1 = require("./payroll");
const filters_1 = require("./filters");
const sorting_1 = require("./sorting");
const permissions_1 = require("./permissions");
const time_1 = require("./time");
const localized_1 = require("./localized");
const Sentry = require("@sentry/browser");
const version_1 = require("./version");
const roster_tabs_1 = require("./roster/roster-tabs");
const rpc_1 = require("./api/rpc");
const time_entry_sync_service_1 = require("./time-entry-sync-service");
exports.DASHBOARD_TILES = {
    birthdays: "Geburtstage",
    sickLeaveRequests: "Krankmeldungen",
    vacationRequests: "Urlaubsanträge",
    expiringContracts: "Auslaufende Verträge",
    notes: "Notizen",
};
class AppSettings {
    constructor() {
        this.rosterDisplayCosts = false;
        this.rosterDisplayTargets = false;
        this.rosterMirrorDepartments = true;
        this.rosterDisplayMode = "regular";
        this.rosterDisplayUnassigned = false;
        this.rosterDisplayAvailabilities = true;
        this.rosterDisplayTimeBalances = true;
        this.rosterDisplayNotes = true;
        this.rosterDisplaySuggestions = true;
        this.rosterDisplayFavSuggestionsOnly = false;
        this.rosterDisplayWeather = true;
        this.timeLogShowEvents = true;
        this.timeLogShowManual = true;
        this.contractsSortDirection = "descending";
        this.dashboardTiles = ["birthdays", "sickLeaveRequests", "vacationRequests", "expiringContracts"];
    }
}
exports.AppSettings = AppSettings;
class State {
    constructor() {
        this.session = null;
        this.account = null;
        this.settings = new AppSettings();
        this.updatedTimeEntries = new Map();
        this.removedTimeEntries = new Map();
        this.employeeFilters = new filters_1.EmployeeFilters();
        this.termsDismissalTimestamp = null;
        this.oneSignalConsentGiven = null;
        this.oneSignalConsentTimestamp = null;
    }
}
exports.State = State;
__decorate([
    (0, class_transformer_1.Type)(() => rpc_1.SessionDTO),
    __metadata("design:type", Object)
], State.prototype, "session", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => rpc_1.AccountDTO),
    __metadata("design:type", Object)
], State.prototype, "account", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => AppSettings),
    __metadata("design:type", AppSettings)
], State.prototype, "settings", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => model_1.TimeEntry),
    __metadata("design:type", Map)
], State.prototype, "updatedTimeEntries", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => model_1.TimeEntry),
    __metadata("design:type", Map)
], State.prototype, "removedTimeEntries", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => filters_1.EmployeeFilters),
    __metadata("design:type", filters_1.EmployeeFilters)
], State.prototype, "employeeFilters", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    (0, class_transformer_1.Type)(() => model_1.Company),
    __metadata("design:type", model_1.Company)
], State.prototype, "company", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], State.prototype, "termsDismissalTimestamp", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], State.prototype, "oneSignalConsentTimestamp", void 0);
class App {
    get account() {
        return this.state.account;
    }
    get company() {
        return this.state.company;
    }
    get profile() {
        if (!this.account || !this.company) {
            return null;
        }
        let profile = this.company.employees.find((e) => e.accountId === this.account.id);
        if (!profile) {
            profile = new model_1.Employee({
                accountId: this.account.id,
                firstName: this.account.firstName,
                lastName: this.account.lastName,
                email: this.account.email,
                positions: [],
                contracts: [],
            });
            this.company.employees.push(profile);
        }
        return profile;
    }
    get venues() {
        var _a;
        return ((_a = this.company) === null || _a === void 0 ? void 0 : _a.venues) || [];
    }
    get accessibleVenues() {
        return this.venues.filter((venue) => this.hasAccess({ venue }));
    }
    get departments() {
        return this.venues.flatMap((v) => v.departments);
    }
    get accessibleDepartments() {
        return this.departments.filter((department) => this.hasAccess({ department }));
    }
    get positions() {
        return this.departments.flatMap((d) => d.positions);
    }
    get archivedPositions() {
        let archivedPositions = [];
        if (!this.company) {
            return [];
        }
        const allVenues = [...this.company.venues, ...this.company.archivedVenues];
        for (const venue of allVenues) {
            const allDepartments = [...venue.departments, ...venue.archivedDepartments];
            for (const department of allDepartments) {
                archivedPositions = archivedPositions.concat(department.archivedPositions);
            }
        }
        return archivedPositions;
    }
    get accessiblePositions() {
        return this.positions.filter((position) => this.hasAccess({ position }));
    }
    get employees() {
        var _a;
        return (((_a = this.company) === null || _a === void 0 ? void 0 : _a.employees.sort((a, b) => (a.lastName > b.lastName ? 1 : a.lastName < b.lastName ? -1 : 0))) ||
            []);
    }
    get accessibleEmployees() {
        return this.employees.filter((employee) => this.hasAccess({ employee }));
    }
    get shiftTemplates() {
        return (this.profile && this.profile.shiftTemplates) || [];
    }
    set shiftTemplates(shiftTemplates) {
        if (this.profile) {
            this.profile.shiftTemplates = shiftTemplates;
            void this.updateAccount({
                profile: { shiftTemplates },
            });
        }
    }
    get rosterTabs() {
        if (!this.profile || !this.company) {
            return [];
        }
        return (0, roster_tabs_1.getProfileOrDefaultRosterTabs)(this.profile.rosterTabs, this.accessibleVenues.filter((venue) => !venue.archived));
    }
    get settings() {
        return this.state.settings;
    }
    get availableTimeSettings() {
        if (!this.company) {
            return [];
        }
        return this.company.settings.availableTimeSettings.sort((a, b) => a.order - b.order);
    }
    get employeeFilters() {
        return this.state.employeeFilters;
    }
    get employeeFiltersActive() {
        return (this.state.employeeFilters.filters.some((f) => !(f.type === "employeeStatus" && f.value === "active")) ||
            !!this.state.employeeFilters.text);
    }
    get locale() {
        var _a;
        return ((_a = this.company) === null || _a === void 0 ? void 0 : _a.country) || "DE";
    }
    get localized() {
        return localized_1.Localized[this.locale];
    }
    constructor(storage, sender, crypto) {
        this.storage = storage;
        this.crypto = crypto;
        this.state = new State();
        this.hasLoaded = false;
        this._subscribers = [];
        this.api = new client_1.Client(sender, crypto, () => {
            var _a;
            return {
                version: (0, version_1.getVersion)(),
                userAgent: navigator.userAgent,
                currentUrl: window.location.href,
                screenWidth: window.screen.width,
                screenHeight: window.screen.height,
                location: (_a = this.state.clientInfo) === null || _a === void 0 ? void 0 : _a.location,
            };
        });
        this._timeEntrySyncService = new time_entry_sync_service_1.TimeEntrySyncService(this.api, this.crypto, this.state);
        // Listen for sync events and save state
        this._timeEntrySyncService.on(time_entry_sync_service_1.SYNC_EVENTS.TIME_ENTRY_STATE_CHANGED, () => {
            this.save().catch((e) => {
                console.error(e);
            });
        });
        this.loaded = this.load();
    }
    async load() {
        var _a;
        // load state from storage
        try {
            const state = await this.storage.get(State, "state");
            await this.update(state);
            if (this.account && this.state.session && this.state.session.scope !== "admin") {
                await Promise.all([this.fetchAccount(), this.fetchCompany()]);
                this._timeEntrySyncService.throttledSyncTimeEntries();
            }
        }
        catch (e) {
            await this.update();
        }
        if (!this.state.employeeFilters) {
            this.resetEmployeeFilters();
        }
        Sentry.setTag("ptc_company_id", (_a = this.company) === null || _a === void 0 ? void 0 : _a.id);
        this.hasLoaded = true;
    }
    async save() {
        if (this.state.session) {
            // @ts-expect-error 2790
            delete this.state.session.account;
        }
        await this.storage.set("state", this.state);
    }
    subscribe(fn) {
        if (this._subscribers.indexOf(fn) === -1) {
            this._subscribers.push(fn);
        }
    }
    unsubscribe(fn) {
        const index = this._subscribers.indexOf(fn);
        if (index === -1) {
            this._subscribers.splice(index, 1);
        }
    }
    publish() {
        for (const fn of this._subscribers) {
            fn(this.state);
        }
    }
    async update(changes) {
        if (changes) {
            Object.assign(this.state, changes);
        }
        this.api.session = this.state.session;
        this.publish();
        await this.save();
    }
    async updateSettings(vals) {
        Object.assign(this.state.settings, vals);
        this.publish();
        await this.save();
    }
    async signup(params) {
        await this.api.createCompany(new api_1.CreateCompanyParams(params));
        await this.login({
            email: params.owner.email,
            password: params.owner.password,
        });
    }
    async login(params) {
        const session = (this.api.session = await this.api.login(new api_1.LoginParams(params)));
        const account = await this.api.me();
        const company = ((session === null || session === void 0 ? void 0 : session.companyId) && (await this.api.getCompany(new api_1.GetCompanyParams({ id: session.companyId })))) ||
            undefined;
        await this.update({ session, account, company });
    }
    async termsNeedToBeAccepted() {
        const lastDismissal = this.state.termsDismissalTimestamp || new Date(0);
        if (Date.now() - lastDismissal.getTime() < time_1.hour * 20) {
            return;
        }
        try {
            const termsState = await this.api.getTermsAndConditionsState();
            if (!termsState || (termsState.termsAccepted && termsState.processingAgreementAccepted)) {
                return;
            }
            return termsState;
        }
        catch (e) {
            console.warn("Error fetching terms and conditions state", e);
        }
        return;
    }
    async selectCompany(companyId) {
        var _a;
        const session = await this.api.selectCompany(companyId);
        const account = await this.api.me();
        const company = (((_a = this.state.session) === null || _a === void 0 ? void 0 : _a.companyId) &&
            (await this.api.getCompany(new api_1.GetCompanyParams({ id: this.state.session.companyId })))) ||
            undefined;
        this._timeEntrySyncService.clearSyncState();
        await this.update({ session, account, company, employeeFilters: new filters_1.EmployeeFilters() });
    }
    async logout() {
        if (this.state.session) {
            try {
                await this.api.revokeSession(new api_1.RevokeSessionParams({ id: this.state.session.id }));
            }
            catch (e) {
                console.error(e);
            }
        }
        const settings = this.state.settings;
        const state = new State();
        state.settings = settings;
        await this.update(state);
    }
    async fetchAccount() {
        const account = await this.api.me();
        await this.update({ account });
    }
    async fetchCompany() {
        var _a;
        const company = (((_a = this.state.session) === null || _a === void 0 ? void 0 : _a.companyId) &&
            (await this.api.getCompany(new api_1.GetCompanyParams({ id: this.state.session.companyId })))) ||
            undefined;
        await this.update({ company });
    }
    async updateAccount(params) {
        await this.api.updateAccount(new api_1.UpdateAccountParams(params));
        await this.fetchAccount();
        if (params.profile) {
            await this.fetchCompany();
        }
    }
    async updateCompany(params) {
        await this.api.updateCompany(new api_1.UpdateCompanyParams(params));
        await this.fetchCompany();
    }
    async createVenue(params) {
        const venue = await this.api.createVenue(new api_1.CreateVenueParams(params));
        await this.fetchCompany();
        return venue;
    }
    async updateVenue(params) {
        const venue = await this.api.updateVenue(new api_1.UpdateVenueParams(params));
        await this.fetchCompany();
        return venue;
    }
    async archiveVenue({ id }) {
        await this.api.archiveVenue(id);
        await this.fetchCompany();
    }
    async createDepartment(params) {
        const dep = await this.api.createDepartment(new api_1.CreateDepartmentParams({ ...params }));
        await this.fetchCompany();
        return dep;
    }
    async updateDepartment(params) {
        const dep = await this.api.updateDepartment(new api_1.UpdateDepartmentParams({ ...params }));
        await this.fetchCompany();
        return dep;
    }
    getDepartment(id) {
        return (this.company && this.company.getDepartment(id)) || { venue: null, department: null };
    }
    getPosition(id) {
        return (this.company && this.company.getPosition(id)) || null;
    }
    getTimeSettings(context) {
        var _a;
        return ((_a = this.company) === null || _a === void 0 ? void 0 : _a.getTimeSettings(context)) || new model_1.TimeSettings();
    }
    getUnplannedShiftPositions(employee, venueId, departments) {
        const positions = [];
        for (const position of employee.positions.filter((p) => !departments || departments.includes(p.departmentId))) {
            const { venue, department } = this.getDepartment(position.departmentId);
            if (!venue ||
                !department ||
                (venueId && venue.id !== venueId) ||
                (departments && !departments.includes(department.id))) {
                continue;
            }
            const { unplannedCheckins, trackingEnabled } = this.getTimeSettings({ employee, position });
            if (trackingEnabled && unplannedCheckins) {
                positions.push({ department, position });
            }
        }
        return positions;
    }
    async archiveDepartment(id) {
        await this.api.archiveDepartment(id);
        await this.fetchCompany();
    }
    async createEmployee(params) {
        const employee = await this.api.createEmployee(new api_1.CreateEmployeeParams(params));
        await this.fetchCompany();
        return employee;
    }
    async updateEmployee({ id }, params, refresh = true) {
        const employee = await this.api.updateEmployee(new api_1.UpdateEmployeeParams({ ...params, id }));
        if (refresh) {
            await this.fetchCompany();
        }
        return employee;
    }
    getEmployee(id) {
        return (this.company && this.company.employees.find((e) => e.id === id)) || null;
    }
    getVenue(venueId) {
        var _a;
        return ((_a = this.company) === null || _a === void 0 ? void 0 : _a.getVenue(venueId)) || null;
    }
    getEmployeesForDepartment(dep, employees = this.employees) {
        if (!this.company) {
            return [];
        }
        return employees
            .filter((emp) => emp.positions.some((p) => p.departmentId === dep.id))
            .sort((a, b) => (0, utils_1.getEmployeeOrderInDepartment)(a, dep) - (0, utils_1.getEmployeeOrderInDepartment)(b, dep));
    }
    async generatePin() {
        let pin;
        // Randomly generate pin until we got a unique one
        do {
            pin = (await (0, utils_1.randomNumber)(0, 9999, this.crypto.randomBytes)).toString().padStart(4, "0");
        } while (this.company.employees.some((e) => e.timePin === pin));
        return pin;
    }
    async getLiveKitAuthToken() {
        return await this.api.getLiveKitAuthToken();
    }
    _normalizeEntry(entry, { applyAutoMeals: autoMeals = false, otherEntries = [], }) {
        if (entry.position && !entry.positionId) {
            entry.positionId = entry.position.id;
        }
        const { trackingEnabled } = this.getTimeSettings({
            timeEntry: entry,
        });
        // If timetracking is disabled for this department, make sure that planned and final time
        // are equal
        if (!trackingEnabled) {
            entry.startPlanned = entry.startFinal = entry.startFinal || entry.startPlanned;
            entry.endPlanned = entry.endFinal = entry.endFinal || entry.endPlanned;
        }
        // If shift is finished, set breaks
        if (entry.final) {
            entry.startBreak = null;
            const { breakMode, autoBreaks } = this.company.getTimeSettings({
                timeEntry: entry,
            });
            (0, time_1.applyAutoBreaks)(entry, breakMode, autoBreaks);
            if (autoMeals) {
                const availableMeals = otherEntries
                    .filter((e) => !e.deleted && e.employeeId === entry.employeeId && e.date === entry.date)
                    .reduce((total, entry) => ({
                    breakfast: total.breakfast && !entry.mealsBreakfast,
                    lunch: total.lunch && !entry.mealsLunch,
                    dinner: total.dinner && !entry.mealsDinner,
                }), {
                    breakfast: true,
                    lunch: true,
                    dinner: true,
                });
                (0, time_1.applyAutoMeals)(this.company, entry, availableMeals);
            }
        }
    }
    async createOrUpdateTimeEntries(entries, { applyAutoMeals = false, otherEntries = [], wait = false, publish = false, setUpdated = true, } = {}) {
        // Normalize entries before passing to service
        const entriesArray = Array.isArray(entries) ? entries : [entries];
        for (const entry of entriesArray) {
            this._normalizeEntry(entry, { applyAutoMeals, otherEntries });
        }
        return this._timeEntrySyncService.createOrUpdateTimeEntries(entries, {
            wait,
            publish,
            setUpdated,
        });
    }
    async removeTimeEntries(entries, wait = false, publish = false) {
        return this._timeEntrySyncService.removeTimeEntries(entries, wait, publish);
    }
    async syncTimeEntries() {
        return this._timeEntrySyncService.syncTimeEntries();
    }
    async getTimeEntries(params) {
        const entries = await this.api.getTimeEntries(new api_1.GetTimeEntriesParams(params));
        const allPositions = [...this.positions, ...this.archivedPositions];
        const positionMap = new Map(allPositions.map((p) => [p.id, p]));
        entries.forEach((entry) => {
            entry.position = (entry.positionId && positionMap.get(entry.positionId)) || null;
        });
        return entries
            .filter((entry) => !this._timeEntrySyncService.isRemoved(entry))
            .map((entry) => this.state.updatedTimeEntries.get(entry.id) || entry);
    }
    hasPermission(scope) {
        return !!this.account && !!this.company && this.company.hasPermission(this.account, scope);
    }
    hasPermissionForEmployee(employee, scope) {
        return this.hasAccess({ employee }) && (!scope || this.hasPermission(scope));
    }
    hasAccess(context) {
        return (this.account &&
            this.profile &&
            this.company &&
            (this.account.admin || this.company.hasAccess(this.profile, context)));
    }
    /**
     * returns all permissions related to the given permission
     * `requires` are all permissions that require the given permission
     * `sub` are all permissions that are sub-permissions of the given permission
     * `sub` also includes the given permission itself
     */
    getRelatedPermissions(key, scopes = permissions_1.PERMISSIONS.children) {
        var _a, _b;
        const res = {
            requires: [],
            sub: [],
        };
        for (const scope of scopes) {
            if (((_a = scope.requires) === null || _a === void 0 ? void 0 : _a.includes(key)) && scope.key) {
                res.requires.push(scope.key);
            }
            if ((_b = scope.key) === null || _b === void 0 ? void 0 : _b.startsWith(key)) {
                res.sub.push(scope.key);
            }
            if (scope.children) {
                const { requires, sub } = this.getRelatedPermissions(key, scope.children);
                res.requires.push(...requires);
                res.sub.push(...sub);
            }
        }
        return res;
    }
    isUpdated(a) {
        return this._timeEntrySyncService.isUpdated(a);
    }
    isRemoved(a) {
        return this._timeEntrySyncService.isRemoved(a);
    }
    getPositionColor(position) {
        var _a;
        return (_a = this.company) === null || _a === void 0 ? void 0 : _a.getPositionColor(position);
    }
    getTimeEntryColor(entry) {
        var _a;
        return (_a = this.company) === null || _a === void 0 ? void 0 : _a.getTimeEntryColor(entry);
    }
    getTimeEntryLabel(entry) {
        var _a;
        const position = entry.positionId ? (_a = this.getPosition(entry.positionId)) === null || _a === void 0 ? void 0 : _a.position : null;
        return (position === null || position === void 0 ? void 0 : position.name) || this.company.getTimeEntryTypeLabel(entry);
    }
    async getPayrollReports(from, to, employees = this.accessibleEmployees.filter((e) => e.status !== model_1.EmployeeStatus.Probation)) {
        const timeEntries = await this.getTimeEntries({
            from: (0, utils_1.getRange)(from, "month").from,
            to: (0, utils_1.getRange)(to, "month").to,
            employee: employees.map((e) => e.id),
        });
        const advances = await this.api.getRevenueEntries(new api_1.GetRevenueEntriesParams({
            from,
            to,
            employee: employees.map((e) => e.id),
            type: [model_1.RevenueType.PayAdvance],
        }));
        const reports = [];
        for (const employee of employees) {
            reports.push((0, payroll_1.getPayrollReport)(this.company, employee, timeEntries.filter((s) => s.employeeId === employee.id), advances.filter((re) => re.employeeId === employee.id), from, to));
        }
        return reports;
    }
    matchTimeSettings(s) {
        var _a;
        return {
            global: ((_a = this.company) === null || _a === void 0 ? void 0 : _a.settings.timeId) === s.id,
            venues: this.venues.filter((v) => v.timeSettingsId === s.id),
            departments: this.venues.flatMap((v) => v.departments.filter((d) => d.timeSettingsId === s.id)),
            employees: this.employees.filter((e) => s.id && e.timeSettingsId === s.id),
        };
    }
    isAvailable(entry, employee, otherEntries, absences, requirePublished = true) {
        var _a;
        const contract = employee.getContractForDate(entry.date);
        return (!entry.startFinal &&
            !entry.endFinal &&
            ((_a = employee.access) === null || _a === void 0 ? void 0 : _a.permissions.includes("staff.roster.take")) &&
            !!employee.accountId &&
            (!entry.employeeId ||
                (entry.employeeId !== employee.id && entry.offered && entry.offered > entry.updated)) &&
            (!requirePublished || entry.isPublished) &&
            !entry.deleted &&
            employee.positions.some((p) => { var _a; return p.id == ((_a = entry.position) === null || _a === void 0 ? void 0 : _a.id); }) &&
            !otherEntries.some((e) => !e.deleted && e.employeeId === employee.id && e.overlapsWith(entry)) &&
            !absences.some((a) => a.employeeId === employee.id && a.start <= entry.date && a.end > entry.date) &&
            !!contract &&
            !contract.blocked);
    }
    updateEmployeeFilters(upd) {
        void this.update({
            employeeFilters: Object.assign(this.employeeFilters, upd),
        });
    }
    resetEmployeeFilters() {
        this.updateEmployeeFilters(new filters_1.EmployeeFilters());
    }
    employeeMatchesFilters(employee, date) {
        const { text, filters } = this.employeeFilters;
        return (`${employee.name} ${employee.staffNumber}`.toLowerCase().includes(text.toLowerCase()) &&
            (0, filters_1.matchesFilters)(filters, { company: this.company, employee, date }));
    }
    getFilteredEmployees(range) {
        const filteredEmployees = this.accessibleEmployees.filter((e) => this.employeeMatchesFilters(e, range));
        const sortedEmployees = (0, filters_1.sortBy)(filteredEmployees, (0, sorting_1.getEmployeeSortProp)(this.employeeFilters.sortProperty), this.employeeFilters.sortDirection);
        return sortedEmployees;
    }
}
exports.App = App;
//# sourceMappingURL=app.js.map